import { NewCourseDetail } from '@/networks/api'
import judgeTokenExp from '@/util/judgeTokenExp'
import types from './types'
import Cookies from 'js-cookie'
import { login } from '../../../util/user'

export default {
  state() {
    return {
      isLoaded: false,
      luboVideo: null,
      courseDetail: null,
      presaleStatus: null,
      cartCount: null,
      dataLoading: true,
      addCartResult: null,
      couponList: null, // 优惠券列表
      couponMessage: null
    }
  },
  mutations: {
    [types.SET_ADD_CART](state, payload) {
      state.addCartResult = payload
    },
    [types.SET_DATA_LOADING](state, payload) {
      state.dataLoading = payload
    },
    [types.SET_CART_COUNT](state, payload) {
      state.cartCount = payload
    },
    [types.SET_IS_LOADED](state, payload) {
      state.isLoaded = payload
    },
    [types.SET_LUBO_VIDEO](state, payload) {
      state.luboVideo = payload
    },
    [types.SET_COURSE_DETAIL](state, payload) {
      state.courseDetail = payload
    },
    [types.UPDATE_COURSE_DETAIL](state, payload) {
      state.courseDetail = Object.assign({}, state.courseDetail, payload)
    },
    [types.SET_NEW_PRESALE_STATUS](state, payload) {
      state.presaleStatus = payload
    },
    [types.SET_COUPON_LIST](state, payload) {
      state.couponList = payload
    },
    [types.SET_COUPON_MESSSAGE](state, payload) {
      state.couponMessage = payload
    }
  },
  actions: {
    async [types.GET_NEW_COURSE_DETAIL]({ commit, rootState }, { route }) {
      try {
        const {
          params: { courseId, classId }
        } = route
        const { batchId } = route.query
        const { data } = await NewCourseDetail.getCourseDetail(
          { courseId, classId },
          {
            rootState,
            cookies: rootState.cookies,
            params: {
              appVersionNumber: 97101,
              xeswx_sourceid: route.query.xeswx_sourceid,
              xeswx_sourceurl: 'https://online.xueersi.com' + route.fullPath,
              batchId
            }
          }
        )
        if(data.data.syllabusModule.list.length) {
          data.data.syllabusModule.list?.map((course) => {
            let lessonIndex = 0
            course?.list.map(unit => {
              unit.lessonIndex = lessonIndex

              unit.list?.map(lesson => {
                lesson.lessonIndex = lessonIndex
                lessonIndex++
              })
            })
          })
        }
        commit(types.SET_COURSE_DETAIL, data.data)
      } catch (e) {
        commit(types.SET_COURSE_DETAIL, null)
        commit(types.SET_INT_PURCHASE, null)
        const response = e.response
        const status = response && response.status
        if (status === 404) return
        console.log('APIERROR==GET_COURSE_DETAIL===', e)
      }
    },
    async [types.GET_NEW_PRESALE_STATUS]({ dispatch, commit, rootState }, params) {
      // 点击预售立即报名按钮
      const { courseId, classId, checkType, xeswx_sourceid, xeswx_sourceurl } = params
      try {
        const { data } = await NewCourseDetail.getPreSaleStatus(
          { courseId, classId, checkType },
          {
            rootState,
            params: {
              xeswx_sourceid,
              xeswx_sourceurl
            }
          }
        )
        console.log(data)
        commit(types.SET_NEW_PRESALE_STATUS, data)
      } catch (e) {
        const response = e.response
        const status = response && response.status
        if (status === 401) {
          await dispatch('GET_TOKEN')
          const { data } = await NewCourseDetail.getPreSaleStatus(
            { courseId, classId },
            {
              rootState,
              params: {
                xeswx_sourceid,
                xeswx_sourceurl
              }
            }
          )
          commit(types.SET_GIFT_CARD, data.data)
          return
        }
        if (status === 404) return
        console.log('APIERROR==GET_PRESALE_STATUS===', e)
      }
    },
    async [types.GET_NEW_ADD_CART]({ dispatch, commit, rootState }, params) {
      try {
        await judgeTokenExp({ dispatch, rootState })

        let newParams = params
        const sourceCode = Cookies.get('xeswx_sourceid', { domain: 'xueersi.com' })

        if (sourceCode) {
          newParams = newParams.map(item => {
            item.sourceCode = sourceCode
            return item
          })
        }

        const {
          data: { result }
        } = await NewCourseDetail.getAddCart(newParams, { rootState })
        commit(types.SET_ADD_CART, result.data)
        if (Number(result.data.status) === 0) {
          const {
            data: { result:_result }
          } = await NewCourseDetail.getCartCount({ rootState })
          commit(types.SET_CART_COUNT, _result.data.num)
        }
      } catch (e) {
        const response = e.response
        const status = response && response.status
        if (status === 401) {
          await dispatch('GET_TOKEN')
          return
        }
        if (status === 404) return
        console.log('APIERROR==GET_ADD_CART==', e)
      }
    },
    async [types.GET_CART_COUNT]({ dispatch, commit, rootState }, { route }) {
      try {
        await judgeTokenExp({ dispatch, rootState })
        const {
          data: { result }
        } = await NewCourseDetail.getCartCount({ rootState })
        commit(types.SET_CART_COUNT, result.data.num)
      } catch (e) {
        const response = e.response
        const status = response && response.status
        if (status === 401) {
          await dispatch('GET_TOKEN')
          return
        }
        if (status === 404) return
        console.log('APIERROR==GET_CART_COUNT==', e)
      }
    },
    async [types.GET_NEW_COUPON_LIST]({ dispatch, commit, rootState }, params) {
      try {
        await judgeTokenExp({ dispatch, rootState })
        const { data } = await NewCourseDetail.getCouponList(params)
        if (data.status === 9) {
          login()
          return
        } else if (data.stat === 1) {
          commit(types.SET_COUPON_LIST, data.data.list)
        }
      } catch (e) {
        const response = e.response
        const status = response && response.status
        if (status === 401) {
          await dispatch('GET_TOKEN')
          return
        }
        commit(types.SET_COUPON_LIST, null)
        if (status === 404) return
        console.log('APIERROR==GET_NEW_COUPON_LIST==', e)
      }
    },
    async [types.GET_NEW_COUPON]({ dispatch, commit, rootState }, params) {
      try {
        await judgeTokenExp({ dispatch, rootState })
        const { data } = await NewCourseDetail.getCoupon({ couponId: params.couponId })
        // if (data.status === 9) {
        // }
        if (data.stat === 1) {
          commit(types.SET_COUPON_MESSSAGE, null)
        } else {
          commit(types.SET_COUPON_MESSSAGE, data.msg)
        }
        dispatch(types.GET_NEW_COUPON_LIST, { courseId: params.courseId })
      } catch (e) {
        const response = e.response
        const status = response && response.status
        if (status === 401) {
          await dispatch('GET_TOKEN')
          return
        }
        commit(types.SET_COUPON_MESSSAGE, null)
        if (status === 404) return
        console.log('APIERROR==GET_NEW_COUPON==', e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/store/index.js